export const styles = {
  dialogContent: {
    width: '480px',
  },
  button: {
    width: '100%',
    textTransform: 'none',
  },
};
